import { render, staticRenderFns } from "./expensesSalaryRow.vue?vue&type=template&id=4985c654&scoped=true&"
import script from "./expensesSalaryRow.vue?vue&type=script&lang=js&"
export * from "./expensesSalaryRow.vue?vue&type=script&lang=js&"
import style0 from "./expensesSalaryRow.vue?vue&type=style&index=0&id=4985c654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985c654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
